export default __webpack_public_path__ + "static/media/certification-wig-en.2776d685.jpeg";